import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { initialState, IOesState } from "./state";

const oes: Module<IOesState, any> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: initialState,
};

export { oes };

